// /opt/isp_erp/frontend/src/components/warehouse/SoloBodegaCentral.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { cargarContextoBodega } from "../../utils/contextoBodega";

/** Pantallas exclusivas de la bodega central: el encargado de una sucursal no entra (se le lleva a Sucursales). */
export default function SoloBodegaCentral({ children }) {
  const [estado, setEstado] = useState("cargando");

  useEffect(() => {
    let vivo = true;
    cargarContextoBodega().then((ctx) => {
      if (vivo) setEstado(ctx && ctx.central === false ? "bloqueado" : "permitido");
    });
    return () => { vivo = false; };
  }, []);

  if (estado === "cargando") {
    return (<Box sx={{ p: 4, textAlign: "center" }}><CircularProgress size={28} /></Box>);
  }
  if (estado === "bloqueado") return <Navigate to="/warehouse/sucursales" replace />;
  return children;
}
